import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useAddUpdateLaborRateViewModel = ({
  onRefresh,
  onClose,
  reset,
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const createLaborRate = async (data) => {
    stateManager.run(async () => {
      const response = await accountService.laborRates.create({
        data,
        toastMessageConfig: {
          success: { text: "Labor Rate Created Successfully!" },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        onRefresh();
        onClose();
        reset();
      }
    });
  };

  const updateLaborRate = async (data) => {
    stateManager.run(async () => {
      const response = await accountService.laborRates.update({
        data,
        id: data.id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: { text: "Labor Rate Updated Successfully!" },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        onRefresh();
        onClose();
      }
    });
  };

  return {
    isLoading,
    createLaborRate,
    updateLaborRate,
  };
};
